import sileo from 'sileo';


const ScheduledTasksEmployment = new sileo.Model('applybpo', 'employment-scheduled-task');
const RecurringTask = new sileo.Model('hqzen', 'recurring-tasks');
const ScheduledTask = new sileo.Model('hqzen', 'scheduled-tasks');
const ScheduledTaskAssignment = new sileo.Model(
    'hqzen', 'scheduled-task-assignment');
const ScheduledTaskDetail = new sileo.Model('hqzen', 'scheduled-task-detail');
// const DisplayScheduledTask = new sileo.Model('hqzen', 'display-scheduled-tasks');

const state = {
    employments: [],
    itemsPerPage: 10,
    maxPages: 0,
};

const getters = {
    employments: state => state.employments,
    employeeInfo: (state) => (employmentId) =>{
        return state.employments.filter(employment => employment.pk === employmentId);
    }
};

const mutations = {
    SET_EMPLOYMENTS(state, employments) {
        state.employments = employments;
    },
    SET_MAX_PAGES(state, maxPages) {
        state.maxPages = maxPages;
    },
};

const actions = {
    async fetchEmployments({ commit, state }, filters) {
        const response = await ScheduledTasksEmployment.objects.filter(filters);
        commit('SET_EMPLOYMENTS', response.objects);
        commit('SET_MAX_PAGES', Math.ceil(response.count / state.itemsPerPage));
    },

    fetchRecurringTasks(_, filters) {
        return RecurringTask.objects.filter(filters);
    },

    // fetchScheduledTaskList(context, filters) {
    //     return DisplayScheduledTask.objects.filter(filters);
    // },

    fetchScheduledTaskList(context, filters) {
        return ScheduledTask.objects.filter(filters);
    },

    createScheduledTask(context, data) {
        const form = new FormData();
        form.append('duration', data.duration );
        form.append('time', data.time );
        form.append('start_date', data.start_date );
        if (data.end_date) {
            form.append('end_date', data.end_date);
        }
        form.append('can_pivot', data.can_pivot ? 'True' : 'False');
        form.append('description', data.description);
        form.append('is_picture_required_before_task', data.is_picture_required_before_task ? 'True' : 'False');
        form.append('is_picture_required_after_task', data.is_picture_required_after_task ? 'True' : 'False');
        form.append('is_inactivity_allowed', data.is_inactivity_allowed ? 'True' : 'False');
        form.append('owner', data.owner);
        form.append('title', data.title);
        form.append('recurrence_rule', data.recurrence_rule);
        form.append('is_progress_photos_required', data.is_progress_photos_required ? 'True' : 'False');
        form.append('progress_photos_count', data.progress_photos_count);
        form.append('is_meeting', data.is_meeting ? 'True' : 'False');
        if (data.assignees) {
            form.append('assignees', Array.isArray(data.assignees) ? data.assignees.join(',') : data.assignees);
        }
        form.append('is_time_constrained', data.is_time_constrained ? 'True' : 'False');
        return ScheduledTask.objects.create(form)
            .then(response => response)
            .catch(error => error);
    },

    updateScheduledTask(context, { id, data }) {
        const form = new FormData();

        // Properly format each field
        if (data.duration !== undefined) form.append('duration', data.duration);
        if (data.time !== undefined) form.append('time', data.time);
        if (data.start_date !== undefined) form.append('start_date', data.start_date);
        if (data.end_date !== undefined && data.end_date !== null) form.append('end_date', data.end_date);
        if (data.can_pivot !== undefined) form.append('can_pivot', data.can_pivot ? 'True' : 'False');
        if (data.description !== undefined) form.append('description', data.description);
        if (data.is_picture_required_before_task !== undefined) {
            form.append('is_picture_required_before_task', data.is_picture_required_before_task ? 'True' : 'False');
        }
        if (data.is_picture_required_after_task !== undefined) {
            form.append('is_picture_required_after_task', data.is_picture_required_after_task ? 'True' : 'False');
        }
        if (data.is_inactivity_allowed !== undefined) {
            form.append('is_inactivity_allowed', data.is_inactivity_allowed ? 'True' : 'False');
        }
        if (data.owner !== undefined) form.append('owner', data.owner);
        if (data.creator !== undefined) form.append('creator', data.creator);
        if (data.title !== undefined) form.append('title', data.title);
        if (data.recurrence_rule !== undefined) form.append('recurrence_rule', data.recurrence_rule);
        if (data.is_progress_photos_required !== undefined) {
            form.append('is_progress_photos_required', data.is_progress_photos_required ? 'True' : 'False');
        }
        if (data.progress_photos_count !== undefined) form.append('progress_photos_count', data.progress_photos_count);
        if (data.is_meeting !== undefined) form.append('is_meeting', data.is_meeting ? 'True' : 'False');
        if (data.assignees !== undefined) {
            form.append('assignees', JSON.stringify(data.assignees));
        }
        if (data.is_time_constrained !== undefined) {
            form.append('is_time_constrained', data.is_time_constrained ? 'True' : 'False');
        }

        return ScheduledTaskDetail.objects.update({ pk: id }, form)
            .then(response => response)
            .catch(error => error);
    },

    fetchScheduledTaskDetails(context, pk) {
        return ScheduledTask.objects.get(pk);
    },

    deleteScheduleTask(_, filters) {
        return ScheduledTask.objects.delete(filters)
        .then(response => response)
        .catch(error => error);
    },

    fetchScheduledTaskAssignment(_, filters) {
        return ScheduledTaskAssignment.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
